(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/quick-bets/assets/javascripts/common/sport-configs.js') >= 0) return;  svs.modules.push('/components/oddset/quick-bets/assets/javascripts/common/sport-configs.js');
"use strict";


const logger = svs.core.log.getLogger('components:oddset:quick-bets:sports-configs');
const {
  SportTypes,
  SportTypeToString
} = svs.components.sport.sportTypes;
const {
  BetOfferTypeId
} = svs.components.oddset.kambiOffering.common.constants;
const SoccerConfig = [{
  betOfferType: BetOfferTypeId.Match,
  englishLabel: 'Full Time',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.OverUnder,
  englishLabel: 'Total Goals',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.Match,
  englishLabel: 'Half Time',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.YesNo,
  englishLabel: 'Both Teams To Score',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.OverUnder,
  englishLabel: 'Total Goals - 1st Half',
  offers: [],
  cssModifier: '--flex'
}];
const HockeyConfig = [{
  betOfferType: BetOfferTypeId.Match,
  englishLabel: 'Match Odds - Regular Time',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.Handicap,
  englishLabel: 'Handicap - Regular Time',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.OverUnder,
  englishLabel: 'Total Goals - Regular Time',
  offers: [],
  cssModifier: '--flex'
}, {
  betOfferType: BetOfferTypeId.Result,
  englishLabel: 'Correct Score - Regular Time',
  offers: [],
  cssModifier: '--result-grid'
}];
const getSportQuickBetConfig = sportType => {
  switch (sportType) {
    case SportTypes.Soccer:
      return SoccerConfig;
    case SportTypes.Hockey:
      return HockeyConfig;
    default:
      logger.info("Unsupported quick-bet sportType: ".concat(SportTypeToString[sportType]));
      return null;
  }
};
setGlobal('svs.components.oddset.quickBets.common.getSportQuickBetConfig', getSportQuickBetConfig);

 })(window);